import React from 'react';
import EventSettingsDataProvider from './EventSettingsDataProvider';
import AppraisersProfileDataProvider from './AppraisersProfileDataProvider';
import EventAssignmentLoadingDataProvider from './EventAssignmentLoadingDataProvider';
import EventTypeDataProvider from './EventTypeDataProvider';

/**
 * @typedef {object} EventContextProviderProps
 * @property {React.ReactNode} children
 * @property {number} pageMode
 * @property {number} [eventStage]
 * @property {*} [eventType]
 * @property {boolean} [isAutoCreated]
 * @property {Array<*>} [eventFlags]
 * @property {number} eventId
 * @property {Array<*>} [atmRoleOptions]
 * @property {Array<*>} [sowContractTypes]
 * @property {boolean} [assignmentsLoading]
 */

/**
 * @param {EventContextProviderProps} props
 */
const EventContextProvider = props => {
  const {
    children,
    pageMode,
    eventStage,
    eventType,
    isAutoCreated,
    eventFlags,
    atmRoleOptions = [],
    sowContractTypes = [],
    eventId,
    assignmentsLoading = false
  } = props;

  return (
    <EventSettingsDataProvider
      pageMode={pageMode}
      eventStage={eventStage}
      eventType={eventType}
      isAutoCreated={isAutoCreated}
      eventFlags={eventFlags}>
      <EventTypeDataProvider atmRoleOptions={atmRoleOptions} sowContractTypes={sowContractTypes}>
        <EventAssignmentLoadingDataProvider assignmentsLoading={assignmentsLoading}>
          <AppraisersProfileDataProvider eventId={eventId}>
            {children}
          </AppraisersProfileDataProvider>
        </EventAssignmentLoadingDataProvider>
      </EventTypeDataProvider>
    </EventSettingsDataProvider>
  );
};

export default EventContextProvider;
